type SparklineProps = {
  values: readonly number[];
  /** What a screen reader announces for the line. */
  label: string;
};

const WIDTH = 96;
const HEIGHT = 24;

/**
 * A tile's trend line (CMP-11.08, ANL-E04-S09): plain SVG, so MetricCard stays out of the chart
 * chunk (AC6). Fewer than two finite points draw nothing.
 */
const Sparkline = ({ values, label }: SparklineProps) => {
  const finite = values.filter((value) => Number.isFinite(value));
  if (finite.length < 2) return null;
  const low = Math.min(...finite);
  const high = Math.max(...finite);
  const range = high - low || 1;
  const points = finite
    .map((value, index) => {
      const x = (index / (finite.length - 1)) * WIDTH;
      const y = HEIGHT - ((value - low) / range) * HEIGHT;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
  return (
    <svg className="pz-sparkline" viewBox={`0 0 ${WIDTH} ${HEIGHT}`} width={WIDTH} height={HEIGHT} role="img" aria-label={label}>
      <polyline points={points} fill="none" stroke="var(--pz-chart-s1)" strokeWidth={1.5} />
    </svg>
  );
};

export default Sparkline;
